var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',{staticClass:"pa-0 pt-0",staticStyle:{"max-width":"400px"},attrs:{"fluid":""}},[_c('vue-headful',{attrs:{"title":"Mein Profil","description":"Aimz"}}),_c('user-data')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }